a.item.display.nfc = (function(){
	var my = {
		popup:function(o){
			var o = o || {};
			var iid = o.iid || null;
			var result = o.result || {};
			var token = a.popup.create({
				slideFrom:'fromleft',
				title:'NFC',
				css_class:'',
				ready:function(token){
					var qrcodeareaid = a.shared.createToken();
					tpl.run({
						tpl:'/tpl/item/display/nfc/page.ejs?v='+v,
						data:{
							qrcodeareaid:qrcodeareaid
						},
						cb:function(c){
							var win = $('#popupid_'+token);
							$('#popupid_'+token+'>.ic').empty().append(c).ready(function(){
								// Write NFC tag
								$('button[data-action="write-nfc-tag"]',win).unbind('click').click(function(){
									my.assignNewTag(result.item.uuid,token);
								});
								// Or, hide button if not permitted
								if (!a.s.ac.allow('content','qr')) {
									$('button[data-action="assign-qr"]',win).parent().hide();
								}
							});
						}
					});
				}
			});
		},
		assignNewTag:function(uuid,token){
			if (a.s.ac.allow('content','qr') && confirm('This will overwrite any existing information on the tag. Do you want to proceed?')) {
				try {
					const ndef = new NDEFReader();
					ndef.write(uuid).then(() => {
						a.s.growl.create('Success','NFC tag written successfully.',{ duration:4000 });
						a.popup.remove(token,function(){});
					}).catch(error => {
						a.s.growl.create('Error','Error writing NFC tag: '+error,{ duration:4000 });
						a.popup.remove(token,function(){});
					});
				} catch (error) {
					a.s.growl.create('Error','Error initializing NDEFReader: '+error,{ duration:4000 });
					a.popup.remove(token,function(){});
				}
			}
		}
	}
	return my;
}());